// extracted by mini-css-extract-plugin
module.exports = {"avatarUploader":"index_avatarUploader__U5FJH","buttonUploader":"index_buttonUploader__HGrir","onBoarding":"index_onBoarding__2G8r2"};